const BookIcon = ({
  size = 16,
  color = 'currentColor',
}: {
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Simple closed book - spine on left */}
      <rect x="3" y="2" width="10" height="12" rx="1" />
      <line x1="6" y1="2" x2="6" y2="14" />
    </svg>
  );
};

export default BookIcon;
